/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, Output, OnInit, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from '../../core/services/localisation/zuper.localisation.service';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import { BadgeOptions } from '../badge/badge.interface';
import { CustomersListOptions } from './customers-list.interface';
import _ from 'lodash';

@Component({
  selector: 'customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomersListComponent implements OnInit, OnChanges {
  @Input() options: CustomersListOptions;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  customers: any[] = [];
  totalCustomers: number = 0;
  totalPages: number;
  paramObj: any = null;
  isLazyLoading: boolean = false;

  constructor(
    private localisationService: LocalisationService,
    private dataCollectorService: DataCollectorService,
    private utilityService: UtilityService) {

  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
  }

  getCustomers(): void {
    if (this.options?.url && this.options?.paramObj) {
      this.paramObj = this.options.paramObj;
      this.dataCollectorService.getData(this.options?.url, this.paramObj)
        .subscribe(
          (customers: any) => {
            this.customers = customers.data;
            this.totalCustomers = customers.total_records;
            this.totalPages = customers.total_pages;
            this.eventEmitter?.emit({ customersCount: this.totalCustomers });
          }, (error: any) => {
            this.eventEmitter?.emit({ customersCount: this.totalCustomers });
          });
    }
  }

  viewCustomersList(_event: any): void {
    this.eventEmitter?.emit({ viewCustomersList: true });
  }

  customerViewDetails(event: any, customerId: string): void {
    this.eventEmitter?.emit({
      viewDetails: true,
      data: {
        event: event,
        type: 'CUSTOMER',
        value: customerId
      }
    });
  }

  organizationViewDetails(event: any, orgId: string): void {
    this.eventEmitter?.emit({
      viewDetails: true,
      data: {
        event: event,
        type: 'ORGANIZATION',
        value: orgId
      }
    });
  }

  showLazyLoading(isLoading: boolean): void {
    this.isLazyLoading = isLoading;
  }

  lazyLoadingEmit(event: any): void {
    if (event?.fetchedData) {
      this.customers = this.customers.concat(event?.fetchedData);
    }
  }

  getBadgeOptions(type: string, displayName?: string, displayKey?: any, color?: string): BadgeOptions {
    return {
      type: type,
      displayKey: displayKey ?? null,
      displayName: displayName ?? (type ? type.toLowerCase() : type),
      color: color ?? null
    };
  }

  displayCustomerInfo(customer): boolean {
    return (
      customer?.['customer_organization'] ||
      customer?.['customer_category'] ||
      customer?.['customer_address']
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('options' in changes && !_.isEqual(changes.options?.currentValue, changes.options?.previousValue)) {
      if (this.options?.data) {
        this.customers = this.options.data;
      }
      
      this.getCustomers();
    }
  }

}
